import { Card, IconTile } from "@design";
import { ChevronRight, FileImage, FileSpreadsheet, FileText, Presentation } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { DocumentLineageResponse, DocumentVersionResponse } from "@/api";
import { Text } from "@/components/Text";
import { extensionOf, imageTypeOf, kindKey } from "./documentInfo";

function fileIcon(ext: string) {
  if (ext === "xlsx" || ext === "csv") return <FileSpreadsheet size={18} />;
  if (ext === "pptx") return <Presentation size={18} />;
  if (imageTypeOf(ext)) return <FileImage size={18} />;
  return <FileText size={18} />;
}

/** A document the reply created or revised; opens it in the documents panel. */
export function DocumentCard({
  doc,
  version,
  onOpen,
}: Readonly<{ doc: DocumentLineageResponse; version: DocumentVersionResponse; onOpen: () => void }>) {
  const { t } = useTranslation("chat", { keyPrefix: "documents" });
  const ext = extensionOf(version.filename, doc.documentType);
  const kind = kindKey(ext);
  return (
    <Card size="sm" onClick={onOpen}>
      <div className="flex items-center gap-3 text-left">
        <IconTile>{fileIcon(ext)}</IconTile>
        <div className="min-w-0 flex-1">
          <Text className="truncate">{version.filename}</Text>
          <Text variant="caption" tone="tertiary">
            {t("card", { kind: t(kind.key as "kinds.other", { ext: kind.ext }), version: version.version })}
          </Text>
        </div>
        <ChevronRight size={16} aria-hidden className="shrink-0 text-content-tertiary" />
      </div>
    </Card>
  );
}
